var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBackhoe(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-backhoe",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 17m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13 17m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13 19l-9 0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4 15l9 0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8 12v-5h2a3 3 0 0 1 3 3v5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5 15v-2a1 1 0 0 1 1 -1h7"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M21.12 9.88l-3.12 -4.88l-5 5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M21.12 9.88a3 3 0 0 1 -2.12 5.12a3 3 0 0 1 -2.12 -.88l4.24 -4.24z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackhoe);
export default __webpack_public_path__ + "static/media/backhoe.bdbca90a.svg";
export { ForwardRef as ReactComponent };